export default "__VITE_ASSET__Bw$YJRqh__"